import * as z from "zod"

import { createEntityFor } from "@axtesys/react-tools"

export type GPtomResponse = {
  transactionId?: string
  merchantId?: string
  timestamp?: string
  currencyCode?: string
  amount?: number
  tipAmount?: number
  batchNumber?: string
  receiptNumber?: string
  terminalId?: string
  europayAppId?: string
  cardIssuer?: string
  cardDataEntry?: string
  cardNumber?: string
  transactionType?: string
  authorizationCode?: string
  sequenceNumber?: string
  responseMessage?: string
}

export type GPtomReceiptData = Omit<
  GPtomResponse,
  "responseMessage" | "merchantId"
>

export const GPtomReceiptDataEntity = createEntityFor<GPtomReceiptData>()
  .withSchema(
    z.object({
      transactionId: z.ostring(),
      timestamp: z.ostring(),
      currencyCode: z.ostring(),
      amount: z.onumber(),
      tipAmount: z.onumber(),
      batchNumber: z.ostring(),
      receiptNumber: z.ostring(),
      terminalId: z.ostring(),
      europayAppId: z.ostring(),
      cardIssuer: z.ostring(),
      cardDataEntry: z.ostring(),
      cardNumber: z.ostring(),
      transactionType: z.ostring(),
      authorizationCode: z.ostring(),
      sequenceNumber: z.ostring(),
    }),
  )
  .serialize(data => data)
  .deserialize(json => json)
